<template>
  <el-select
    :value="driver"
    @change="emitDriverUpdated($event)"
    remote
    filterable
    reserve-keyword
    value-key="id"
    placeholder="請輸入車隊呼號"
    :remote-method="handleDriverInfoInput"
  >
    <el-option
      v-for="item in options"
      :key="item.value.id"
      :label="item.label"
      :value="item.value"
    ></el-option>
  </el-select>
</template>

<script>
import longTermCareService from '@/API/longTermCareService'

const parseToOption = (driver) => ({
  label: `${driver.callNumber}-${driver.name}`,
  value: driver,
})

export default {
  props: {
    preferParams: {
      type: Object,
      default: function () {
        return {}
      },
    },
    driver: {
      type: [Object, String],
      default: function () {
        return {}
      },
    },
  },
  data() {
    return {
      availableDrivers: [],
      options: [],
    }
  },
  beforeUpdate() {
    if (this.driver && this.availableDrivers.length === 0) {
      this.options = [this.driver].map(parseToOption)
    }
  },
  methods: {
    emitDriverUpdated(selected) {
      this.$emit('driver-updated', {
        driver: selected,
        driverId: selected.id,
        licenseNumber: selected.licenseNumber,
      })
    },
    handleDriverInfoInput(query) {
      const { service: { suv, wheelchair, highBackWheelchair } = {} } =
        this.preferParams

      const { driver } = this
      const params = {
        suv,
        wheelchair,
        highBackWheelchair,
        // driver_name: query,
        call_number: query,
      }

      longTermCareService
        .searchDriver(params)
        .then(({ result }) => {
          this.availableDrivers = result

          if (!result) return []
          return result.length > 0 && result.map(parseToOption)
        })
        .then((result) => {
          this.options = result.filter((item) => {
            if (!item.label || !query) return false
            return item.label.toLowerCase().indexOf(query.toLowerCase()) > -1
          })
        })
        .catch(({ data: { error }, message }) => {
          this.options = []
          return this.$message.error(message || error.message)
        })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/longTermCare/DriverSelector.vue